var map = {
	"./MENU-appetizer-1.jpg": 2752,
	"./MENU-appetizer-2.jpg": 6367,
	"./MENU-combo-1.jpg": 5156,
	"./MENU-combo-2.jpg": 6787,
	"./MENU-noodle-1.jpg": 957,
	"./MENU-partytray-1.jpg": 1182,
	"./MENU-sashimi-1.jpg": 5970,
	"./MENU-sashimi-2.jpg": 1549,
	"./MENU-sushi-1.jpg": 3360,
	"./MENU-sushi-2.jpg": 7087,
	"./MENU-sushiRoll-1.jpg": 21,
	"./MENU-sushiRoll-2.jpg": 122,
	"./MENU-sushiRoll-3.jpg": 5959,
	"./MENU-sushiRoll-4.jpg": 9964,
	"./MENU-sushiRoll-5.jpg": 4665,
	"./MENU-sushiRoll-6.jpg": 3902,
	"./MENU-sushiRoll-7.jpg": 1947,
	"./image-replacement-1.jpg": 1138,
	"./image-replacement-2.jpg": 1037,
	"./image-replacement-3.jpg": 1808
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5920;